import { parseTimeShortText } from 'src/utils/time';
import type { DynamicQuestionAnswerValue, DynamicQuestionData } from './types';
import { QuestionTypeTypeKey } from './types';

export function isRequiredQuestionAnswered(
  question: DynamicQuestionData,
  value: DynamicQuestionAnswerValue,
): boolean {
  const isRequired = Boolean(question.isRequired);
  if (!isRequired) return true;

  const typeKey = question.questionType?.typeKey ?? null;
  if (!typeKey) return true;

  switch (typeKey) {
    case QuestionTypeTypeKey.SHORT_TEXT:
    case QuestionTypeTypeKey.NUMBER:
    case QuestionTypeTypeKey.LONG_TEXT:
      return (value.text ?? '').trim() !== '';

    case QuestionTypeTypeKey.DATE_TIME:
      return value.text?.trim() !== '' || Boolean(value.dateTimeUnsure);

    case QuestionTypeTypeKey.TIME:
      return parseTimeShortText(value.text) != null;

    case QuestionTypeTypeKey.DROPDOWN:
    case QuestionTypeTypeKey.RADIO:
      return (value.selectedOptionId ?? '').trim() !== '';

    case QuestionTypeTypeKey.CHECKBOX:
    case QuestionTypeTypeKey.MULTIPLE_CHOICE:
      return (value.selectedOptionIds?.length ?? 0) > 0;

    case QuestionTypeTypeKey.DATA_GRID: {
      const minRows = question.dataGridConfig?.minRows ?? 0;
      const rows = value.dataGridRows ?? [];
      return rows.length >= minRows;
    }

    case QuestionTypeTypeKey.FILE_UPLOAD:
      return (
        (value.evidenceUploadFiles?.length ?? 0) > 0 ||
        (value.uploadedFiles?.length ?? 0) > 0 ||
        (value.fileNames?.length ?? 0) > 0
      );

    default:
      return true;
  }
}
